import { render, staticRenderFns } from "./SelectStrategy.vue?vue&type=template&id=4ca8929a&scoped=true&"
import script from "./SelectStrategy.vue?vue&type=script&lang=ts&"
export * from "./SelectStrategy.vue?vue&type=script&lang=ts&"
import style0 from "./SelectStrategy.vue?vue&type=style&index=0&id=4ca8929a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8929a",
  null
  
)

export default component.exports